import { safeClearStorage } from './safeStorage';

const deleteOriginCaches = async (): Promise<number> => {
  if (typeof window === 'undefined' || !('caches' in window)) return 0;

  const cacheNames = await window.caches.keys();
  await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
  return cacheNames.length;
};

export interface FrontendCacheClearResult {
  browserCaches: number;
}

export const clearFrontendGeneratedCaches = async (): Promise<FrontendCacheClearResult> => {
  safeClearStorage('local');
  safeClearStorage('session');
  const browserCaches = await deleteOriginCaches();

  window.dispatchEvent(new CustomEvent('truevined-frontend-cache-cleared'));

  return { browserCaches };
};
